/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface FormaExpandedTooltipProps {
	className?: string;
	visible?: boolean;
	position?: 'left' | 'right' | 'top' | 'bottom';
	text: string;
	shortcut?: string;
	loadingduration?: number;
	opendelay?: number;
	expanded_?: boolean;
	targetId?: string;
	helpUrl?: string;
	targetShadowRoot?: string;
	children?: React.ReactNode;
}

export function FormaExpandedTooltip({
	className,
	visible,
	position = 'left',
	text,
	shortcut,
	loadingduration = 1000,
	opendelay = 300,
	expanded_,
	targetId,
	helpUrl,
	targetShadowRoot,
	children,
}: FormaExpandedTooltipProps) {
	const hostRef = useRef<HTMLDivElement>(null);
	const [tooltipEl, setTooltipEl] = useState<HTMLElement | null>(null);

	useLayoutEffect(() => {
		const el = document.createElement('forma-expanded-tooltip');

		const setAttr = (name: string, value: any) => {
			if (value !== undefined && value !== null) {
				el.setAttribute(name, String(value));
			}
		};

		if (targetId) setAttr('target-id', targetId);
		setAttr('text', text);
		setAttr('position', position);
		setAttr('loadingduration', loadingduration);
		setAttr('opendelay', opendelay);

		if (shortcut) setAttr('shortcut', shortcut);
		if (helpUrl) setAttr('help-url', helpUrl);
		if (targetShadowRoot) setAttr('target-shadow-root', targetShadowRoot);

		if (visible) el.setAttribute('visible', '');
		if (expanded_) el.setAttribute('expanded_', '');

		if (className) el.className = className;

		if (hostRef.current) {
			hostRef.current.innerHTML = '';
			hostRef.current.appendChild(el);
			setTooltipEl(el);
		}

		return () => {
			// eslint-disable-next-line react-hooks/exhaustive-deps
			if (hostRef.current) hostRef.current.innerHTML = '';
		};
	}, [
		targetId,
		text,
		position,
		visible,
		expanded_,
		helpUrl,
		shortcut,
		loadingduration,
		opendelay,
		targetShadowRoot,
		className,
	]);

	return (
		<div ref={hostRef} style={{ display: 'contents' }}>
			{tooltipEl && children && createPortal(children, tooltipEl)}
		</div>
	);
}
